<script setup lang="ts">

import type MapCoordinate from '@/types/MapCoordinate.ts'
import {computed} from "vue";
import {useAssetStore} from "@/stores/assetStore.ts";
import StarAnimation from '@/components/Elements/Animations/Star/StarAnimation.vue'
import GenericIconWithColoredNumber from '@/components/Elements/Images/Icons/GenericIconWithColoredNumber.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const assetStore = useAssetStore()

const props = defineProps<{
  coordinate: MapCoordinate
}>();

const starTypeData = computed(() => {
  return assetStore.findStarTypeById(props.coordinate.typeVariant)
})

const starNameMap: Record<number, string> = {
  1: 'map.stars.neutron',
  2: 'map.stars.whiteDwarf',
  3: 'map.stars.redGiant',
  4: 'map.stars.redDwarf',
  5: 'map.stars.kType',
  6: 'map.stars.gType',
  7: 'map.stars.fType',
  8: 'map.stars.aType',
  9: 'map.stars.bType',
  10: 'map.stars.oType'
}

const starName = computed(() => {
  const key = starNameMap[props.coordinate.typeVariant]
  return key ? t(key) : t('map.stars.unknown')
})

</script>

<template>
  <div class="background border-metal-800 border">
    <div class="flex justify-between">
      <div class="text-center text-subtext p-1">
        {{ starName }}
      </div>
      <div class="text-center text-subtext p-1 mr-1" :title="t('map.tooltips.starEnergyOutput')">
        <GenericIconWithColoredNumber :amount="starTypeData?.energyOutput ?? 0" type="energy"/>
      </div>
    </div>
    <div class="flex justify-center items-center star-image">
      <StarAnimation :type="props.coordinate.typeVariant"/>
    </div>
  </div>
</template>

<style scoped lang="scss">
.star-image {
  height: 9.9rem;
  min-width: 9.9rem;
  overflow: hidden;
}
.background {
  background-image: url("https://cdn.ferion.com/images/backgrounds/space.webp");
}
</style>